// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".earned-coupon[data-v-6ccf4f8f]{display:inline-block;width:350px}", ""]);
// Exports
module.exports = exports;
